import { render } from "./resource-v1.vue?vue&type=template&id=7b75ba9f&scoped=true"
import script from "./resource-v1.vue?vue&type=script&lang=js"
export * from "./resource-v1.vue?vue&type=script&lang=js"

import "./resource-v1.vue?vue&type=style&index=0&id=7b75ba9f&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b75ba9f"]])

export default __exports__